interface Player {
  name: string;
  score: number;
}

interface LeaderboardProps {
  players: Player[];
  currentPlayer?: string;
  highlightTop?: boolean;
  showTitle?: boolean;
}

function Leaderboard({ players, currentPlayer, highlightTop = true, showTitle = true }: LeaderboardProps) {
  const sortedPlayers = [...players].sort((a, b) => b.score - a.score);

  return (
    <div className="w-full max-w-2xl">
      {showTitle && <h2 className="text-3xl font-bold mb-6 text-center">Leaderboard</h2>}
      <div className="space-y-3">
        {sortedPlayers.map((p, i) => {
          const isMe = !!currentPlayer && p.name === currentPlayer;
          const isFirst = i === 0;
          let style: string;
          if (isMe) {
            style = highlightTop && isFirst ? 'bg-yellow-600 text-white text-xl' : 'bg-blue-600 text-white';
          } else if (!currentPlayer && highlightTop && isFirst) {
            style = 'bg-yellow-600 text-white text-xl';
          } else {
            style = 'bg-gray-800 bg-opacity-50 text-white';
          }
          return (
            <p
              key={`${p.name}-${i}`}
              className={`p-3 rounded-lg text-lg font-medium ${style}`}
            >
              {i + 1}. {p.name}: {p.score}
              {isMe && ' (You)'}
            </p>
          );
        })}
      </div>
    </div>
  );
}

export default Leaderboard;
